var _path, _path2, _rect, _path3, _circle, _circle2, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 50 50",
    height: "50px",
    id: "Layer_1",
    viewBox: "0 0 50 50",
    width: "50px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45,44v3c0,1.104-0.896,2-2,2h-4  c-1.104,0-2-0.896-2-2v-2",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,45v2c0,1.104-0.896,2-2,2H7  c-1.103,0-2-0.896-2-2v-3",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 50,
    width: 50
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46,9c0-5.161-1-8-6-8H12C6,1,4,2.714,4,8  c0,4,0,17.919,0,21.846C4,35.617,4,41,4,41c0,3.312,2.688,4,6,4h30c3.312,0,6-0.688,6-4c0,0,0-4.426,0-11.154C46,25.85,46,13,46,9z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 37.5,
    fill: "none",
    r: 3.5,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 37.5,
    fill: "none",
    r: 3.5,
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46,13h2c0.553,0,1,0.448,1,1v8c0,0.552-0.447,1-1,1  h-2",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4,13H2c-0.552,0-1,0.448-1,1v8c0,0.552,0.448,1,1,1  h2",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37,7c0,0.552-0.447,1-1,1H15c-0.552,0-1-0.448-1-1  V5c0-0.552,0.448-1,1-1h21c0.553,0,1,0.448,1,1V7z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39,28.922L11,29c-2,0-3-1-3-3c0-3,0-8.859,0-12  c0-2,1-3,3-3c9,0,15.713,0,28,0c2,0,3,1,3,3s0,10.977,0,12C42,28,40.047,28.922,39,28.922z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus1);
export default __webpack_public_path__ + "static/media/bus-1.03b9ec9418edf3fd45b23cc336129f93.svg";
export { ForwardRef as ReactComponent };